// CTA constants
const NEW_TAB = "New Tab";
const POPUP = "Popup";
const DOWNLOADABLE = "Downloadable";
const AS_ANCHOR = "Anchor";

export { NEW_TAB, POPUP, DOWNLOADABLE, AS_ANCHOR };
